// extracted by mini-css-extract-plugin
module.exports = {"button":"articles_button__-FFat","sending":"articles_sending__1f6qr"};